import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Table, Radio, Input, Button, Icon, Tag, Tooltip } from "antd";
import styles from "./IndividuTaula.module.css";
import {
  paginacioPerDefecte,
  ordenarAttribut,
  obtenirEstatPerDefecte,
  seleccionarPaginacio
} from "../commons/TaulaOrdenacioCerca";
import {
  esborrarIndividuSeleccionat,
  canviTextCercaVista
} from "../../actions";
import { rutaDetallIndividu } from "../../routes";
import { TEXT_QUAN_NO_HI_HA_DADA } from "../../constantsFormularis";
import { getCercaVistes } from "../../reducers";

const columnaNomObservador = "nomObservador";
const columnaNomIndret = "nomIndret";
const columnaNomComu = "nomComu";
const columnaDescripcio = "descripcio";
const columnaFenofases = "fenofases";
const columnaDataAlta = "dataAltaIndretIndividu";
const columnaEstat = "estat";

// Aquesta parametrització de columnes està relacionada amb el mètode obtenirConfiguracioColumnes()
const columnesAmbFiltres = [
  columnaNomObservador,
  columnaNomIndret,
  columnaDescripcio,
  columnaNomComu,
  columnaFenofases,
  columnaDataAlta,
  columnaEstat
];

class IndividuTaula extends Component {
  constructor(props) {
    super(props);
    const { individus } = props;
    this.state = obtenirEstatPerDefecte(individus, columnesAmbFiltres);
  }

  componentDidMount() {
    this.props.esborrarIndividuSeleccionat();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.individus !== nextProps.individus) {
      const { individus } = nextProps;
      this.setState(() =>
        obtenirEstatPerDefecte(individus, columnesAmbFiltres)
      );
    }
  }

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Cerca...`}
          value={selectedKeys && selectedKeys[0] ? selectedKeys[0] : null}
          onChange={e => {
            setSelectedKeys(e.target.value ? [e.target.value] : []);
          }}
          onPressEnter={() => {
            this.handleSearch(selectedKeys, confirm, dataIndex);
            this.props.canviTextCercaVista(selectedKeys[0], dataIndex);
          }}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => {
            this.handleSearch(selectedKeys, confirm, dataIndex);
            this.props.canviTextCercaVista(selectedKeys[0], dataIndex);
          }}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => {
            this.handleReset(clearFilters);
            this.props.canviTextCercaVista("", "");
          }}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
    ),

    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    }
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  obtenirConfiguracioColumnaFenofases(nom, item, amplada) {
    return {
      title: nom,
      width: amplada ? amplada : 150,
      key: item,
      dataIndex: item,
      render: item => (
        <div>
          {item.map(tag => {
            return (
              <Tooltip
                placement="top"
                overlayStyle={{ whiteSpace: "pre-line" }}
                title={tag.nom}
              >
                <Tag color="blue" key={tag}>
                  {tag.codiBbch}
                </Tag>
              </Tooltip>
            );
          })}
        </div>
      )
    };
  }

  obtenirConfiguracioColumnaOrdenadaIFiltrada(
    nom,
    item,
    tipus,
    amplada,
    valorFilter
  ) {
    return {
      title: nom,
      width: amplada ? amplada : 150,
      dataIndex: item,
      key: item,
      filteredValue: valorFilter ? [valorFilter] : null,
      sorter: (itemA, itemB) => ordenarAttribut(itemA, itemB, item, tipus),
      render: text => text || TEXT_QUAN_NO_HI_HA_DADA,
      ...this.getColumnSearchProps(item)
    };
  }

  obtenirConfiguracioColumnes(cercaVistes) {
    return [
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Observador",
        columnaNomObservador,
        null,
        150,
        cercaVistes.columnaCerca === columnaNomObservador
          ? cercaVistes.textCerca
          : null
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Indret",
        columnaNomIndret,
        null,
        150,
        cercaVistes.columnaCerca === columnaNomIndret
          ? cercaVistes.textCerca
          : null
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Espècie",
        columnaNomComu,
        null,
        140,
        cercaVistes.columnaCerca === columnaNomComu
          ? cercaVistes.textCerca
          : null
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Descripció",
        columnaDescripcio,
        null,
        150,
        cercaVistes.columnaCerca === columnaDescripcio
          ? cercaVistes.textCerca
          : null
      ),
      this.obtenirConfiguracioColumnaFenofases(
        "Fenofases",
        columnaFenofases,
        105
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Data Alta",
        columnaDataAlta,
        null,
        120,
        cercaVistes.columnaCerca === columnaDataAlta
          ? cercaVistes.textCerca
          : null
      ),
      this.obtenirConfiguracioColumnaOrdenadaIFiltrada(
        "Estat",
        columnaEstat,
        null,
        100,
        cercaVistes.columnaCerca === columnaEstat ? cercaVistes.textCerca : null
      )
    ];
  }

  onClickIndividu(idIndividu) {
    const { history, getDadesIndividuSeleccionat } = this.props;
    getDadesIndividuSeleccionat(idIndividu);
    history.push({
      pathname: rutaDetallIndividu
    });
  }

  render() {
    const { paginacio } = this.state;
    const { cercaVistes } = this.props;
    const mostrarSelectorPaginacio =
      this.state.data.length > 0 ? "block" : "none";

    return (
      <div className={styles.individuTaula}>
        <Table
          dataSource={this.state.data}
          columns={this.obtenirConfiguracioColumnes(cercaVistes)}
          pagination={{ pageSize: paginacio, position: "bottom" }}
          bordered
          scroll={{ x: "max-content", y: 600 }}
          size="middle"
          onRow={record => ({
            onClick: () => {
              this.onClickIndividu(parseInt(record.id, 0));
            }
          })}
          rowKey={record => record.id}
        />
        <Radio.Group
          className={styles.individuTaulaSelectorPaginacio}
          size="small"
          onChange={event =>
            seleccionarPaginacio(event.target.value, this.setState.bind(this))}
          style={{ display: mostrarSelectorPaginacio }}
          value={paginacio}
        >
          <Radio.Button value={paginacioPerDefecte}>
            {paginacioPerDefecte}
          </Radio.Button>
          <Radio.Button value={40}>40</Radio.Button>
          <Radio.Button value={60}>60</Radio.Button>
          <Radio.Button value={100}>100</Radio.Button>
        </Radio.Group>
      </div>
    );
  }
}

IndividuTaula.propTypes = {
  onClickIndividu: PropTypes.func,
  individus: PropTypes.arrayOf(
    PropTypes.shape({
      nom: PropTypes.string
    })
  ),
  history: PropTypes.object,
  getDadesIndividuSeleccionat: PropTypes.func,
  esborrarIndividuSeleccionat: PropTypes.func,
  canviTextCercaVista: PropTypes.func,
  cercaVistes: PropTypes.object
};

const mapStateToProps = state => {
  return {
    cercaVistes: getCercaVistes(state)
  };
};

const mapDispatchToProps = {
  esborrarIndividuSeleccionat,
  canviTextCercaVista
};

export default connect(mapStateToProps, mapDispatchToProps)(IndividuTaula);
